// Data kept both in this browser (cache) and on the server (live), such
// as the settings and the user highlights: which copy to go on from
// (recent), the other one (stale, merged in later), and whether the server
// needs this browser's copy. isValid says whether a copy holds anything.
export const pickRecent = (cache, live, isValid) => {
  const cacheValid = !!cache && isValid(cache)
  const liveValid = !!live && isValid(live)
  if (cacheValid && !liveValid) {
    // nothing on the server: this browser's copy goes up
    return { recent: cache, stale: live, needUpload: true }
  }
  if (liveValid && !cacheValid) {
    return { recent: live, stale: cache, needUpload: false }
  }
  if (!cacheValid && !liveValid) {
    // start from scratch
    return { recent: null, stale: null, needUpload: true }
  }
  const same =
    live._timestamp === cache._timestamp && live._version === cache._version
  const cacheNewer = live._timestamp < cache._timestamp
  return same || cacheNewer
    ? { recent: cache, stale: live, needUpload: false }
    : { recent: live, stale: cache, needUpload: false }
}
